import axios from "axios";

const UserInstance = axios.create({
  baseURL: "https://admin-portal-kc.navaantrix.com/keycloak", // backend base url
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,OPTIONS",
  },
});

// Attach token automatically
UserInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default UserInstance;
